import { BrowserRouter, Route, Routes } from "react-router";
import Layout from "./Layout";
import Error from "./pages/error/Error";
// import GuestPosts from "./pages/GuestPosts/GuestPosts.jsx";
import Home from "./pages/Home/Home.jsx";
// import Milestones from "./pages/Milestones/Milestones.jsx";
// import Projects from "./pages/Projects/Projects.jsx";

export default function Routes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          {/* <Route path="/guest-posts" element={<GuestPosts />} />
          <Route path="/milestones" element={<Milestones />} />
          <Route path="/projects" element={<Projects />} /> */}
          <Route path="*" element={<Error />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
